import { render, staticRenderFns } from "./QualificationAdd.vue?vue&type=template&id=39525d6b&"
import script from "./QualificationAdd.vue?vue&type=script&lang=js&"
export * from "./QualificationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports